// --- React
import React from "react";
// --- Styles
import "./styles.scss";

/**
 * ValidationError Component
 *
 * A reusable component for displaying form validation error messages.
 * Renders nothing if no error is provided.
 *
 * @param {Object} props
 * @param {string} props.error - The error message to display
 * @param {string} [props.className] - Additional CSS class names
 * @returns {JSX.Element|null}
 *
 * @example
 * // Basic usage
 * <ValidationError error={errors.username} />
 *
 * @example
 * // With custom className
 * <ValidationError error={errors.email} className="custom-error" />
 */
export const ValidationError = ({ error, className = "" }) => {
  if (!error) return null;

  const classNames = ["validation-error", className].filter(Boolean).join(" ");

  return <div className={classNames}>{error}</div>;
};

export default ValidationError;
